// test2695
(2695 && 0);
